import React, { useEffect, useState } from 'react';

const images = [
  '/portada1.jpg',
  '/portada2.jpg',
  '/portada3.jpg'
];

const Hero = () => {
  const [current, setCurrent] = useState(0);

  const phoneNumber = '3184476101';
  const whatsappMessage = encodeURIComponent(
    'Hola, Quisiera tener información acerca de ...'
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative w-full h-screen bg-black overflow-hidden">
      {/* Slider */}
      {images.map((img, index) => (
        <img
          key={index}
          src={img}
          alt="slider"
          className={`
            absolute inset-0 w-full h-full
            object-contain md:object-cover
            transition-opacity duration-1000
            ${index === current ? 'opacity-100' : 'opacity-0'}
          `}
        />
      ))}

      {/* WhatsApp */}
      <a
        href={`https://wa.me/57${phoneNumber}?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        className="
          fixed bottom-5 right-5 z-50
          w-14 h-14 md:w-16 md:h-16
          bg-green-500 hover:bg-green-600
          rounded-full
          shadow-lg hover:shadow-xl
          flex items-center justify-center
          transition-all duration-300
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="w-7 h-7 md:w-8 md:h-8 fill-white"
        >
          <path d="M16.04 2.003c-7.732 0-14 6.268-14 14 0 2.47.646 4.79 1.774 6.81L2 30l7.406-1.93A13.93 13.93 0 0016.04 30c7.732 0 14-6.268 14-14s-6.268-14-14-14zm0 25.5c-2.148 0-4.246-.566-6.09-1.637l-.437-.26-4.392 1.144 1.17-4.276-.283-.438A11.447 11.447 0 014.54 16c0-6.352 5.148-11.5 11.5-11.5s11.5 5.148 11.5 11.5-5.148 11.5-11.5 11.5zm6.285-8.597c-.344-.172-2.034-1.003-2.35-1.118-.315-.115-.544-.172-.773.172-.23.344-.888 1.118-1.09 1.348-.201.23-.402.258-.745.086-.344-.172-1.453-.536-2.768-1.71-1.023-.912-1.714-2.04-1.916-2.383-.201-.344-.022-.53.151-.701.156-.156.344-.402.516-.603.172-.201.23-.344.344-.573.115-.23.058-.43-.029-.602-.086-.172-.773-1.86-1.058-2.55-.277-.667-.558-.577-.773-.588l-.659-.012c-.23 0-.602.086-.916.43-.315.344-1.2 1.172-1.2 2.86s1.23 3.318 1.4 3.547c.172.23 2.417 3.692 5.855 5.18.818.353 1.455.564 1.952.722.82.26 1.566.223 2.155.135.657-.098 2.034-.831 2.32-1.635.287-.803.287-1.492.201-1.635-.086-.144-.315-.23-.659-.402z" />
        </svg>
      </a>
    </section>
  );
};

export default Hero;